export default __webpack_public_path__ + "static/media/ic_multichain.e577f4fa.svg";